/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Api
 * Postify AI API specification
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  Brainstorm,
  BrainstormsListResponse,
  CreateBrainstormRequest,
  CreateIdeaRequest,
  DeleteAudioTranscriptBody,
  ExpandIdeaRequest,
  ExpandIdeaResponse,
  GenerateAllPlatformsRequest,
  GenerateAllPlatformsResponse,
  GenerateCTARequest,
  GenerateCTAResponse,
  GenerateHashtagsRequest,
  GenerateHashtagsResponse,
  GenerateHooksRequest,
  GenerateHooksResponse,
  GeneratePostRequest,
  GeneratePostResponse,
  GenerateSmartReplyRequest,
  GenerateSmartReplyResponse,
  GenerateThreadRequest,
  GenerateThreadResponse,
  GetIdeasParams,
  GetPostsParams,
  GetReplyHistoryParams,
  HealthStatus,
  Idea,
  IdeasListResponse,
  ImportUrlRequest,
  ImportUrlResponse,
  Post,
  PostsListResponse,
  RefinePostRequest,
  ReplyHistoryResponse,
  RepurposeRequest,
  RepurposeResponse,
  ResetVoiceProfile200,
  TrainAudioRequest,
  TrainAudioResponse,
  TrainVoiceRequest,
  TrainVoiceResponse,
  TranscribeRequest,
  TranscribeResponse,
  UpdateIdeaRequest,
  UploadMediaResponse,
  UploadVoiceMediaBody,
  VoiceFeedbackRequest,
  VoiceFeedbackResponse,
  VoiceProfile,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get voice profile for current session
 */
export const getGetVoiceProfileUrl = () => {
  return `/api/voice/profile`;
};

export const getVoiceProfile = async (
  options?: RequestInit,
): Promise<VoiceProfile> => {
  return customFetch<VoiceProfile>(getGetVoiceProfileUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetVoiceProfileQueryKey = () => {
  return [`/api/voice/profile`] as const;
};

export const getGetVoiceProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getVoiceProfile>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getVoiceProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVoiceProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVoiceProfile>>> = ({
    signal,
  }) => getVoiceProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVoiceProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVoiceProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVoiceProfile>>
>;
export type GetVoiceProfileQueryError = ErrorType<unknown>;

/**
 * @summary Get voice profile for current session
 */

export function useGetVoiceProfile<
  TData = Awaited<ReturnType<typeof getVoiceProfile>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getVoiceProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVoiceProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Reset voice profile (wipe samples and analysis, keep preferences)
 */
export const getResetVoiceProfileUrl = () => {
  return `/api/voice/profile`;
};

export const resetVoiceProfile = async (
  options?: RequestInit,
): Promise<ResetVoiceProfile200> => {
  return customFetch<ResetVoiceProfile200>(getResetVoiceProfileUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getResetVoiceProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetVoiceProfile>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetVoiceProfile>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["resetVoiceProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetVoiceProfile>>,
    void
  > = () => {
    return resetVoiceProfile(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetVoiceProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetVoiceProfile>>
>;

export type ResetVoiceProfileMutationError = ErrorType<unknown>;

/**
 * @summary Reset voice profile (wipe samples and analysis, keep preferences)
 */
export const useResetVoiceProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetVoiceProfile>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetVoiceProfile>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getResetVoiceProfileMutationOptions(options));
};

/**
 * @summary Add writing samples to train the AI voice
 */
export const getTrainVoiceUrl = () => {
  return `/api/voice/train`;
};

export const trainVoice = async (
  trainVoiceRequest: TrainVoiceRequest,
  options?: RequestInit,
): Promise<TrainVoiceResponse> => {
  return customFetch<TrainVoiceResponse>(getTrainVoiceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(trainVoiceRequest),
  });
};

export const getTrainVoiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trainVoice>>,
    TError,
    { data: BodyType<TrainVoiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trainVoice>>,
  TError,
  { data: BodyType<TrainVoiceRequest> },
  TContext
> => {
  const mutationKey = ["trainVoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trainVoice>>,
    { data: BodyType<TrainVoiceRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return trainVoice(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrainVoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof trainVoice>>
>;
export type TrainVoiceMutationBody = BodyType<TrainVoiceRequest>;
export type TrainVoiceMutationError = ErrorType<unknown>;

/**
 * @summary Add writing samples to train the AI voice
 */
export const useTrainVoice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trainVoice>>,
    TError,
    { data: BodyType<TrainVoiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof trainVoice>>,
  TError,
  { data: BodyType<TrainVoiceRequest> },
  TContext
> => {
  return useMutation(getTrainVoiceMutationOptions(options));
};

/**
 * @summary Train voice from audio recording
 */
export const getTrainVoiceAudioUrl = () => {
  return `/api/voice/train-audio`;
};

export const trainVoiceAudio = async (
  trainAudioRequest: TrainAudioRequest,
  options?: RequestInit,
): Promise<TrainAudioResponse> => {
  return customFetch<TrainAudioResponse>(getTrainVoiceAudioUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(trainAudioRequest),
  });
};

export const getTrainVoiceAudioMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trainVoiceAudio>>,
    TError,
    { data: BodyType<TrainAudioRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trainVoiceAudio>>,
  TError,
  { data: BodyType<TrainAudioRequest> },
  TContext
> => {
  const mutationKey = ["trainVoiceAudio"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trainVoiceAudio>>,
    { data: BodyType<TrainAudioRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return trainVoiceAudio(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrainVoiceAudioMutationResult = NonNullable<
  Awaited<ReturnType<typeof trainVoiceAudio>>
>;
export type TrainVoiceAudioMutationBody = BodyType<TrainAudioRequest>;
export type TrainVoiceAudioMutationError = ErrorType<unknown>;

/**
 * @summary Train voice from audio recording
 */
export const useTrainVoiceAudio = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trainVoiceAudio>>,
    TError,
    { data: BodyType<TrainAudioRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof trainVoiceAudio>>,
  TError,
  { data: BodyType<TrainAudioRequest> },
  TContext
> => {
  return useMutation(getTrainVoiceAudioMutationOptions(options));
};

/**
 * @summary Delete an audio transcript by index
 */
export const getDeleteAudioTranscriptUrl = () => {
  return `/api/voice/delete-audio-transcript`;
};

export const deleteAudioTranscript = async (
  deleteAudioTranscriptBody: DeleteAudioTranscriptBody,
  options?: RequestInit,
): Promise<TrainVoiceResponse> => {
  return customFetch<TrainVoiceResponse>(getDeleteAudioTranscriptUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(deleteAudioTranscriptBody),
  });
};

export const getDeleteAudioTranscriptMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAudioTranscript>>,
    TError,
    { data: BodyType<DeleteAudioTranscriptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAudioTranscript>>,
  TError,
  { data: BodyType<DeleteAudioTranscriptBody> },
  TContext
> => {
  const mutationKey = ["deleteAudioTranscript"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAudioTranscript>>,
    { data: BodyType<DeleteAudioTranscriptBody> }
  > = (props) => {
    const { data } = props ?? {};

    return deleteAudioTranscript(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAudioTranscriptMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAudioTranscript>>
>;
export type DeleteAudioTranscriptMutationBody =
  BodyType<DeleteAudioTranscriptBody>;
export type DeleteAudioTranscriptMutationError = ErrorType<unknown>;

/**
 * @summary Delete an audio transcript by index
 */
export const useDeleteAudioTranscript = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAudioTranscript>>,
    TError,
    { data: BodyType<DeleteAudioTranscriptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAudioTranscript>>,
  TError,
  { data: BodyType<DeleteAudioTranscriptBody> },
  TContext
> => {
  return useMutation(getDeleteAudioTranscriptMutationOptions(options));
};

/**
 * @summary Transcribe audio to text
 */
export const getTranscribeAudioUrl = () => {
  return `/api/voice/transcribe`;
};

export const transcribeAudio = async (
  transcribeRequest: TranscribeRequest,
  options?: RequestInit,
): Promise<TranscribeResponse> => {
  return customFetch<TranscribeResponse>(getTranscribeAudioUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(transcribeRequest),
  });
};

export const getTranscribeAudioMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transcribeAudio>>,
    TError,
    { data: BodyType<TranscribeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transcribeAudio>>,
  TError,
  { data: BodyType<TranscribeRequest> },
  TContext
> => {
  const mutationKey = ["transcribeAudio"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transcribeAudio>>,
    { data: BodyType<TranscribeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return transcribeAudio(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TranscribeAudioMutationResult = NonNullable<
  Awaited<ReturnType<typeof transcribeAudio>>
>;
export type TranscribeAudioMutationBody = BodyType<TranscribeRequest>;
export type TranscribeAudioMutationError = ErrorType<unknown>;

/**
 * @summary Transcribe audio to text
 */
export const useTranscribeAudio = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transcribeAudio>>,
    TError,
    { data: BodyType<TranscribeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof transcribeAudio>>,
  TError,
  { data: BodyType<TranscribeRequest> },
  TContext
> => {
  return useMutation(getTranscribeAudioMutationOptions(options));
};

/**
 * @summary Submit feedback on a generated post or reply (thumbs up adds to voice training)
 */
export const getSubmitVoiceFeedbackUrl = () => {
  return `/api/voice/feedback`;
};

export const submitVoiceFeedback = async (
  voiceFeedbackRequest: VoiceFeedbackRequest,
  options?: RequestInit,
): Promise<VoiceFeedbackResponse> => {
  return customFetch<VoiceFeedbackResponse>(getSubmitVoiceFeedbackUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(voiceFeedbackRequest),
  });
};

export const getSubmitVoiceFeedbackMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitVoiceFeedback>>,
    TError,
    { data: BodyType<VoiceFeedbackRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitVoiceFeedback>>,
  TError,
  { data: BodyType<VoiceFeedbackRequest> },
  TContext
> => {
  const mutationKey = ["submitVoiceFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitVoiceFeedback>>,
    { data: BodyType<VoiceFeedbackRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return submitVoiceFeedback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitVoiceFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitVoiceFeedback>>
>;
export type SubmitVoiceFeedbackMutationBody = BodyType<VoiceFeedbackRequest>;
export type SubmitVoiceFeedbackMutationError = ErrorType<unknown>;

/**
 * @summary Submit feedback on a generated post or reply (thumbs up adds to voice training)
 */
export const useSubmitVoiceFeedback = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitVoiceFeedback>>,
    TError,
    { data: BodyType<VoiceFeedbackRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitVoiceFeedback>>,
  TError,
  { data: BodyType<VoiceFeedbackRequest> },
  TContext
> => {
  return useMutation(getSubmitVoiceFeedbackMutationOptions(options));
};

/**
 * @summary Upload a video or audio file for voice training
 */
export const getUploadVoiceMediaUrl = () => {
  return `/api/voice/upload-media`;
};

export const uploadVoiceMedia = async (
  uploadVoiceMediaBody: UploadVoiceMediaBody,
  options?: RequestInit,
): Promise<UploadMediaResponse> => {
  const formData = new FormData();
  formData.append(`file`, uploadVoiceMediaBody.file);

  return customFetch<UploadMediaResponse>(getUploadVoiceMediaUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadVoiceMediaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadVoiceMedia>>,
    TError,
    { data: BodyType<UploadVoiceMediaBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadVoiceMedia>>,
  TError,
  { data: BodyType<UploadVoiceMediaBody> },
  TContext
> => {
  const mutationKey = ["uploadVoiceMedia"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadVoiceMedia>>,
    { data: BodyType<UploadVoiceMediaBody> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadVoiceMedia(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadVoiceMediaMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadVoiceMedia>>
>;
export type UploadVoiceMediaMutationBody = BodyType<UploadVoiceMediaBody>;
export type UploadVoiceMediaMutationError = ErrorType<unknown>;

/**
 * @summary Upload a video or audio file for voice training
 */
export const useUploadVoiceMedia = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadVoiceMedia>>,
    TError,
    { data: BodyType<UploadVoiceMediaBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadVoiceMedia>>,
  TError,
  { data: BodyType<UploadVoiceMediaBody> },
  TContext
> => {
  return useMutation(getUploadVoiceMediaMutationOptions(options));
};

/**
 * @summary Extract text from a social media post URL
 */
export const getImportUrlUrl = () => {
  return `/api/voice/import-url`;
};

export const importUrl = async (
  importUrlRequest: ImportUrlRequest,
  options?: RequestInit,
): Promise<ImportUrlResponse> => {
  return customFetch<ImportUrlResponse>(getImportUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(importUrlRequest),
  });
};

export const getImportUrlMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importUrl>>,
    TError,
    { data: BodyType<ImportUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importUrl>>,
  TError,
  { data: BodyType<ImportUrlRequest> },
  TContext
> => {
  const mutationKey = ["importUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importUrl>>,
    { data: BodyType<ImportUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return importUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof importUrl>>
>;
export type ImportUrlMutationBody = BodyType<ImportUrlRequest>;
export type ImportUrlMutationError = ErrorType<unknown>;

/**
 * @summary Extract text from a social media post URL
 */
export const useImportUrl = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importUrl>>,
    TError,
    { data: BodyType<ImportUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof importUrl>>,
  TError,
  { data: BodyType<ImportUrlRequest> },
  TContext
> => {
  return useMutation(getImportUrlMutationOptions(options));
};

/**
 * @summary Generate posts for all platforms simultaneously
 */
export const getGenerateAllPlatformsUrl = () => {
  return `/api/posts/generate-all`;
};

export const generateAllPlatforms = async (
  generateAllPlatformsRequest: GenerateAllPlatformsRequest,
  options?: RequestInit,
): Promise<GenerateAllPlatformsResponse> => {
  return customFetch<GenerateAllPlatformsResponse>(
    getGenerateAllPlatformsUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(generateAllPlatformsRequest),
    },
  );
};

export const getGenerateAllPlatformsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateAllPlatforms>>,
    TError,
    { data: BodyType<GenerateAllPlatformsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateAllPlatforms>>,
  TError,
  { data: BodyType<GenerateAllPlatformsRequest> },
  TContext
> => {
  const mutationKey = ["generateAllPlatforms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateAllPlatforms>>,
    { data: BodyType<GenerateAllPlatformsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return generateAllPlatforms(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateAllPlatformsMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateAllPlatforms>>
>;
export type GenerateAllPlatformsMutationBody =
  BodyType<GenerateAllPlatformsRequest>;
export type GenerateAllPlatformsMutationError = ErrorType<unknown>;

/**
 * @summary Generate posts for all platforms simultaneously
 */
export const useGenerateAllPlatforms = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateAllPlatforms>>,
    TError,
    { data: BodyType<GenerateAllPlatformsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateAllPlatforms>>,
  TError,
  { data: BodyType<GenerateAllPlatformsRequest> },
  TContext
> => {
  return useMutation(getGenerateAllPlatformsMutationOptions(options));
};

/**
 * @summary Generate a social media post from an idea
 */
export const getGeneratePostUrl = () => {
  return `/api/posts/generate`;
};

export const generatePost = async (
  generatePostRequest: GeneratePostRequest,
  options?: RequestInit,
): Promise<GeneratePostResponse> => {
  return customFetch<GeneratePostResponse>(getGeneratePostUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generatePostRequest),
  });
};

export const getGeneratePostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generatePost>>,
    TError,
    { data: BodyType<GeneratePostRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generatePost>>,
  TError,
  { data: BodyType<GeneratePostRequest> },
  TContext
> => {
  const mutationKey = ["generatePost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generatePost>>,
    { data: BodyType<GeneratePostRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return generatePost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GeneratePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof generatePost>>
>;
export type GeneratePostMutationBody = BodyType<GeneratePostRequest>;
export type GeneratePostMutationError = ErrorType<unknown>;

/**
 * @summary Generate a social media post from an idea
 */
export const useGeneratePost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generatePost>>,
    TError,
    { data: BodyType<GeneratePostRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generatePost>>,
  TError,
  { data: BodyType<GeneratePostRequest> },
  TContext
> => {
  return useMutation(getGeneratePostMutationOptions(options));
};

/**
 * @summary Get generated posts history
 */
export const getGetPostsUrl = (params?: GetPostsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/posts?${stringifiedParams}`
    : `/api/posts`;
};

export const getPosts = async (
  params?: GetPostsParams,
  options?: RequestInit,
): Promise<PostsListResponse> => {
  return customFetch<PostsListResponse>(getGetPostsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetPostsQueryKey = (params?: GetPostsParams) => {
  return [`/api/posts`, ...(params ? [params] : [])] as const;
};

export const getGetPostsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPosts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPostsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPosts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPostsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPosts>>> = ({
    signal,
  }) => getPosts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPosts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPosts>>
>;
export type GetPostsQueryError = ErrorType<unknown>;

/**
 * @summary Get generated posts history
 */

export function useGetPosts<
  TData = Awaited<ReturnType<typeof getPosts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPostsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPosts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPostsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a specific post
 */
export const getGetPostUrl = (postId: string) => {
  return `/api/posts/${postId}`;
};

export const getPost = async (
  postId: string,
  options?: RequestInit,
): Promise<Post> => {
  return customFetch<Post>(getGetPostUrl(postId), {
    ...options,
    method: "GET",
  });
};

export const getGetPostQueryKey = (postId: string) => {
  return [`/api/posts/${postId}`] as const;
};

export const getGetPostQueryOptions = <
  TData = Awaited<ReturnType<typeof getPost>>,
  TError = ErrorType<unknown>,
>(
  postId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPost>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPostQueryKey(postId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPost>>> = ({
    signal,
  }) => getPost(postId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!postId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPost>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetPostQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPost>>
>;
export type GetPostQueryError = ErrorType<unknown>;

/**
 * @summary Get a specific post
 */

export function useGetPost<
  TData = Awaited<ReturnType<typeof getPost>>,
  TError = ErrorType<unknown>,
>(
  postId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPost>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPostQueryOptions(postId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Delete a post
 */
export const getDeletePostUrl = (postId: string) => {
  return `/api/posts/${postId}`;
};

export const deletePost = async (
  postId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeletePostUrl(postId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePost>>,
    TError,
    { postId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePost>>,
  TError,
  { postId: string },
  TContext
> => {
  const mutationKey = ["deletePost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePost>>,
    { postId: string }
  > = (props) => {
    const { postId } = props ?? {};

    return deletePost(postId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePost>>
>;

export type DeletePostMutationError = ErrorType<unknown>;

/**
 * @summary Delete a post
 */
export const useDeletePost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePost>>,
    TError,
    { postId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePost>>,
  TError,
  { postId: string },
  TContext
> => {
  return useMutation(getDeletePostMutationOptions(options));
};

/**
 * @summary Refine an existing post (shorten, expand, adjust tone)
 */
export const getRefinePostUrl = (postId: string) => {
  return `/api/posts/${postId}/refine`;
};

export const refinePost = async (
  postId: string,
  refinePostRequest: RefinePostRequest,
  options?: RequestInit,
): Promise<GeneratePostResponse> => {
  return customFetch<GeneratePostResponse>(getRefinePostUrl(postId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(refinePostRequest),
  });
};

export const getRefinePostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refinePost>>,
    TError,
    { postId: string; data: BodyType<RefinePostRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refinePost>>,
  TError,
  { postId: string; data: BodyType<RefinePostRequest> },
  TContext
> => {
  const mutationKey = ["refinePost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refinePost>>,
    { postId: string; data: BodyType<RefinePostRequest> }
  > = (props) => {
    const { postId, data } = props ?? {};

    return refinePost(postId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefinePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof refinePost>>
>;
export type RefinePostMutationBody = BodyType<RefinePostRequest>;
export type RefinePostMutationError = ErrorType<unknown>;

/**
 * @summary Refine an existing post (shorten, expand, adjust tone)
 */
export const useRefinePost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refinePost>>,
    TError,
    { postId: string; data: BodyType<RefinePostRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refinePost>>,
  TError,
  { postId: string; data: BodyType<RefinePostRequest> },
  TContext
> => {
  return useMutation(getRefinePostMutationOptions(options));
};

/**
 * @summary Get idea vault
 */
export const getGetIdeasUrl = (params?: GetIdeasParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ideas?${stringifiedParams}`
    : `/api/ideas`;
};

export const getIdeas = async (
  params?: GetIdeasParams,
  options?: RequestInit,
): Promise<IdeasListResponse> => {
  return customFetch<IdeasListResponse>(getGetIdeasUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetIdeasQueryKey = (params?: GetIdeasParams) => {
  return [`/api/ideas`, ...(params ? [params] : [])] as const;
};

export const getGetIdeasQueryOptions = <
  TData = Awaited<ReturnType<typeof getIdeas>>,
  TError = ErrorType<unknown>,
>(
  params?: GetIdeasParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIdeas>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIdeasQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIdeas>>> = ({
    signal,
  }) => getIdeas(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIdeas>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetIdeasQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIdeas>>
>;
export type GetIdeasQueryError = ErrorType<unknown>;

/**
 * @summary Get idea vault
 */

export function useGetIdeas<
  TData = Awaited<ReturnType<typeof getIdeas>>,
  TError = ErrorType<unknown>,
>(
  params?: GetIdeasParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIdeas>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetIdeasQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save an idea to the vault
 */
export const getCreateIdeaUrl = () => {
  return `/api/ideas`;
};

export const createIdea = async (
  createIdeaRequest: CreateIdeaRequest,
  options?: RequestInit,
): Promise<Idea> => {
  return customFetch<Idea>(getCreateIdeaUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createIdeaRequest),
  });
};

export const getCreateIdeaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createIdea>>,
    TError,
    { data: BodyType<CreateIdeaRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createIdea>>,
  TError,
  { data: BodyType<CreateIdeaRequest> },
  TContext
> => {
  const mutationKey = ["createIdea"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createIdea>>,
    { data: BodyType<CreateIdeaRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createIdea(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateIdeaMutationResult = NonNullable<
  Awaited<ReturnType<typeof createIdea>>
>;
export type CreateIdeaMutationBody = BodyType<CreateIdeaRequest>;
export type CreateIdeaMutationError = ErrorType<unknown>;

/**
 * @summary Save an idea to the vault
 */
export const useCreateIdea = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createIdea>>,
    TError,
    { data: BodyType<CreateIdeaRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createIdea>>,
  TError,
  { data: BodyType<CreateIdeaRequest> },
  TContext
> => {
  return useMutation(getCreateIdeaMutationOptions(options));
};

/**
 * @summary Update an idea
 */
export const getUpdateIdeaUrl = (ideaId: string) => {
  return `/api/ideas/${ideaId}`;
};

export const updateIdea = async (
  ideaId: string,
  updateIdeaRequest: UpdateIdeaRequest,
  options?: RequestInit,
): Promise<Idea> => {
  return customFetch<Idea>(getUpdateIdeaUrl(ideaId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateIdeaRequest),
  });
};

export const getUpdateIdeaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateIdea>>,
    TError,
    { ideaId: string; data: BodyType<UpdateIdeaRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateIdea>>,
  TError,
  { ideaId: string; data: BodyType<UpdateIdeaRequest> },
  TContext
> => {
  const mutationKey = ["updateIdea"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateIdea>>,
    { ideaId: string; data: BodyType<UpdateIdeaRequest> }
  > = (props) => {
    const { ideaId, data } = props ?? {};

    return updateIdea(ideaId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateIdeaMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateIdea>>
>;
export type UpdateIdeaMutationBody = BodyType<UpdateIdeaRequest>;
export type UpdateIdeaMutationError = ErrorType<unknown>;

/**
 * @summary Update an idea
 */
export const useUpdateIdea = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateIdea>>,
    TError,
    { ideaId: string; data: BodyType<UpdateIdeaRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateIdea>>,
  TError,
  { ideaId: string; data: BodyType<UpdateIdeaRequest> },
  TContext
> => {
  return useMutation(getUpdateIdeaMutationOptions(options));
};

/**
 * @summary Delete an idea
 */
export const getDeleteIdeaUrl = (ideaId: string) => {
  return `/api/ideas/${ideaId}`;
};

export const deleteIdea = async (
  ideaId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteIdeaUrl(ideaId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteIdeaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteIdea>>,
    TError,
    { ideaId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteIdea>>,
  TError,
  { ideaId: string },
  TContext
> => {
  const mutationKey = ["deleteIdea"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteIdea>>,
    { ideaId: string }
  > = (props) => {
    const { ideaId } = props ?? {};

    return deleteIdea(ideaId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteIdeaMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteIdea>>
>;

export type DeleteIdeaMutationError = ErrorType<unknown>;

/**
 * @summary Delete an idea
 */
export const useDeleteIdea = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteIdea>>,
    TError,
    { ideaId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteIdea>>,
  TError,
  { ideaId: string },
  TContext
> => {
  return useMutation(getDeleteIdeaMutationOptions(options));
};

/**
 * @summary List brainstorm entries
 */
export const getGetBrainstormsUrl = () => {
  return `/api/brainstorms`;
};

export const getBrainstorms = async (
  options?: RequestInit,
): Promise<BrainstormsListResponse> => {
  return customFetch<BrainstormsListResponse>(getGetBrainstormsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBrainstormsQueryKey = () => {
  return [`/api/brainstorms`] as const;
};

export const getGetBrainstormsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBrainstorms>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBrainstorms>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBrainstormsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrainstorms>>> = ({
    signal,
  }) => getBrainstorms({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBrainstorms>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBrainstormsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBrainstorms>>
>;
export type GetBrainstormsQueryError = ErrorType<unknown>;

/**
 * @summary List brainstorm entries
 */

export function useGetBrainstorms<
  TData = Awaited<ReturnType<typeof getBrainstorms>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBrainstorms>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBrainstormsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save a brainstorm entry
 */
export const getCreateBrainstormUrl = () => {
  return `/api/brainstorms`;
};

export const createBrainstorm = async (
  createBrainstormRequest: CreateBrainstormRequest,
  options?: RequestInit,
): Promise<Brainstorm> => {
  return customFetch<Brainstorm>(getCreateBrainstormUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createBrainstormRequest),
  });
};

export const getCreateBrainstormMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBrainstorm>>,
    TError,
    { data: BodyType<CreateBrainstormRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBrainstorm>>,
  TError,
  { data: BodyType<CreateBrainstormRequest> },
  TContext
> => {
  const mutationKey = ["createBrainstorm"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBrainstorm>>,
    { data: BodyType<CreateBrainstormRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createBrainstorm(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBrainstormMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBrainstorm>>
>;
export type CreateBrainstormMutationBody = BodyType<CreateBrainstormRequest>;
export type CreateBrainstormMutationError = ErrorType<unknown>;

/**
 * @summary Save a brainstorm entry
 */
export const useCreateBrainstorm = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBrainstorm>>,
    TError,
    { data: BodyType<CreateBrainstormRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBrainstorm>>,
  TError,
  { data: BodyType<CreateBrainstormRequest> },
  TContext
> => {
  return useMutation(getCreateBrainstormMutationOptions(options));
};

/**
 * @summary Delete a brainstorm entry
 */
export const getDeleteBrainstormUrl = (brainstormId: string) => {
  return `/api/brainstorms/${brainstormId}`;
};

export const deleteBrainstorm = async (
  brainstormId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteBrainstormUrl(brainstormId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteBrainstormMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBrainstorm>>,
    TError,
    { brainstormId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBrainstorm>>,
  TError,
  { brainstormId: string },
  TContext
> => {
  const mutationKey = ["deleteBrainstorm"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBrainstorm>>,
    { brainstormId: string }
  > = (props) => {
    const { brainstormId } = props ?? {};

    return deleteBrainstorm(brainstormId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBrainstormMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBrainstorm>>
>;

export type DeleteBrainstormMutationError = ErrorType<unknown>;

/**
 * @summary Delete a brainstorm entry
 */
export const useDeleteBrainstorm = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBrainstorm>>,
    TError,
    { brainstormId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBrainstorm>>,
  TError,
  { brainstormId: string },
  TContext
> => {
  return useMutation(getDeleteBrainstormMutationOptions(options));
};

/**
 * @summary Generate viral hooks for a topic
 */
export const getGenerateHooksUrl = () => {
  return `/api/tools/hooks`;
};

export const generateHooks = async (
  generateHooksRequest: GenerateHooksRequest,
  options?: RequestInit,
): Promise<GenerateHooksResponse> => {
  return customFetch<GenerateHooksResponse>(getGenerateHooksUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateHooksRequest),
  });
};

export const getGenerateHooksMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateHooks>>,
    TError,
    { data: BodyType<GenerateHooksRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateHooks>>,
  TError,
  { data: BodyType<GenerateHooksRequest> },
  TContext
> => {
  const mutationKey = ["generateHooks"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateHooks>>,
    { data: BodyType<GenerateHooksRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return generateHooks(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateHooksMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateHooks>>
>;
export type GenerateHooksMutationBody = BodyType<GenerateHooksRequest>;
export type GenerateHooksMutationError = ErrorType<unknown>;

/**
 * @summary Generate viral hooks for a topic
 */
export const useGenerateHooks = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateHooks>>,
    TError,
    { data: BodyType<GenerateHooksRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateHooks>>,
  TError,
  { data: BodyType<GenerateHooksRequest> },
  TContext
> => {
  return useMutation(getGenerateHooksMutationOptions(options));
};

/**
 * @summary Generate a Twitter/X thread
 */
export const getGenerateThreadUrl = () => {
  return `/api/tools/thread`;
};

export const generateThread = async (
  generateThreadRequest: GenerateThreadRequest,
  options?: RequestInit,
): Promise<GenerateThreadResponse> => {
  return customFetch<GenerateThreadResponse>(getGenerateThreadUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateThreadRequest),
  });
};

export const getGenerateThreadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateThread>>,
    TError,
    { data: BodyType<GenerateThreadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateThread>>,
  TError,
  { data: BodyType<GenerateThreadRequest> },
  TContext
> => {
  const mutationKey = ["generateThread"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateThread>>,
    { data: BodyType<GenerateThreadRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return generateThread(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateThread>>
>;
export type GenerateThreadMutationBody = BodyType<GenerateThreadRequest>;
export type GenerateThreadMutationError = ErrorType<unknown>;

/**
 * @summary Generate a Twitter/X thread
 */
export const useGenerateThread = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateThread>>,
    TError,
    { data: BodyType<GenerateThreadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateThread>>,
  TError,
  { data: BodyType<GenerateThreadRequest> },
  TContext
> => {
  return useMutation(getGenerateThreadMutationOptions(options));
};

/**
 * @summary Repurpose a post across platforms
 */
export const getRepurposePostUrl = () => {
  return `/api/tools/repurpose`;
};

export const repurposePost = async (
  repurposeRequest: RepurposeRequest,
  options?: RequestInit,
): Promise<RepurposeResponse> => {
  return customFetch<RepurposeResponse>(getRepurposePostUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(repurposeRequest),
  });
};

export const getRepurposePostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof repurposePost>>,
    TError,
    { data: BodyType<RepurposeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof repurposePost>>,
  TError,
  { data: BodyType<RepurposeRequest> },
  TContext
> => {
  const mutationKey = ["repurposePost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof repurposePost>>,
    { data: BodyType<RepurposeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return repurposePost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RepurposePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof repurposePost>>
>;
export type RepurposePostMutationBody = BodyType<RepurposeRequest>;
export type RepurposePostMutationError = ErrorType<unknown>;

/**
 * @summary Repurpose a post across platforms
 */
export const useRepurposePost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof repurposePost>>,
    TError,
    { data: BodyType<RepurposeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof repurposePost>>,
  TError,
  { data: BodyType<RepurposeRequest> },
  TContext
> => {
  return useMutation(getRepurposePostMutationOptions(options));
};

/**
 * @summary Generate hashtags for a post
 */
export const getGenerateHashtagsUrl = () => {
  return `/api/tools/hashtags`;
};

export const generateHashtags = async (
  generateHashtagsRequest: GenerateHashtagsRequest,
  options?: RequestInit,
): Promise<GenerateHashtagsResponse> => {
  return customFetch<GenerateHashtagsResponse>(getGenerateHashtagsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateHashtagsRequest),
  });
};

export const getGenerateHashtagsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateHashtags>>,
    TError,
    { data: BodyType<GenerateHashtagsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateHashtags>>,
  TError,
  { data: BodyType<GenerateHashtagsRequest> },
  TContext
> => {
  const mutationKey = ["generateHashtags"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateHashtags>>,
    { data: BodyType<GenerateHashtagsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return generateHashtags(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateHashtagsMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateHashtags>>
>;
export type GenerateHashtagsMutationBody = BodyType<GenerateHashtagsRequest>;
export type GenerateHashtagsMutationError = ErrorType<unknown>;

/**
 * @summary Generate hashtags for a post
 */
export const useGenerateHashtags = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateHashtags>>,
    TError,
    { data: BodyType<GenerateHashtagsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateHashtags>>,
  TError,
  { data: BodyType<GenerateHashtagsRequest> },
  TContext
> => {
  return useMutation(getGenerateHashtagsMutationOptions(options));
};

/**
 * @summary Generate call-to-action options
 */
export const getGenerateCTAUrl = () => {
  return `/api/tools/cta`;
};

export const generateCTA = async (
  generateCTARequest: GenerateCTARequest,
  options?: RequestInit,
): Promise<GenerateCTAResponse> => {
  return customFetch<GenerateCTAResponse>(getGenerateCTAUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateCTARequest),
  });
};

export const getGenerateCTAMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateCTA>>,
    TError,
    { data: BodyType<GenerateCTARequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateCTA>>,
  TError,
  { data: BodyType<GenerateCTARequest> },
  TContext
> => {
  const mutationKey = ["generateCTA"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateCTA>>,
    { data: BodyType<GenerateCTARequest> }
  > = (props) => {
    const { data } = props ?? {};

    return generateCTA(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateCTAMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateCTA>>
>;
export type GenerateCTAMutationBody = BodyType<GenerateCTARequest>;
export type GenerateCTAMutationError = ErrorType<unknown>;

/**
 * @summary Generate call-to-action options
 */
export const useGenerateCTA = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateCTA>>,
    TError,
    { data: BodyType<GenerateCTARequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateCTA>>,
  TError,
  { data: BodyType<GenerateCTARequest> },
  TContext
> => {
  return useMutation(getGenerateCTAMutationOptions(options));
};

/**
 * @summary Expand a rough idea into content angles
 */
export const getExpandIdeaUrl = () => {
  return `/api/tools/expand-idea`;
};

export const expandIdea = async (
  expandIdeaRequest: ExpandIdeaRequest,
  options?: RequestInit,
): Promise<ExpandIdeaResponse> => {
  return customFetch<ExpandIdeaResponse>(getExpandIdeaUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(expandIdeaRequest),
  });
};

export const getExpandIdeaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof expandIdea>>,
    TError,
    { data: BodyType<ExpandIdeaRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof expandIdea>>,
  TError,
  { data: BodyType<ExpandIdeaRequest> },
  TContext
> => {
  const mutationKey = ["expandIdea"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof expandIdea>>,
    { data: BodyType<ExpandIdeaRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return expandIdea(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExpandIdeaMutationResult = NonNullable<
  Awaited<ReturnType<typeof expandIdea>>
>;
export type ExpandIdeaMutationBody = BodyType<ExpandIdeaRequest>;
export type ExpandIdeaMutationError = ErrorType<unknown>;

/**
 * @summary Expand a rough idea into content angles
 */
export const useExpandIdea = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof expandIdea>>,
    TError,
    { data: BodyType<ExpandIdeaRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof expandIdea>>,
  TError,
  { data: BodyType<ExpandIdeaRequest> },
  TContext
> => {
  return useMutation(getExpandIdeaMutationOptions(options));
};

/**
 * @summary Generate a polished reply to an email or message
 */
export const getGenerateSmartReplyUrl = () => {
  return `/api/reply/generate`;
};

export const generateSmartReply = async (
  generateSmartReplyRequest: GenerateSmartReplyRequest,
  options?: RequestInit,
): Promise<GenerateSmartReplyResponse> => {
  return customFetch<GenerateSmartReplyResponse>(getGenerateSmartReplyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateSmartReplyRequest),
  });
};

export const getGenerateSmartReplyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSmartReply>>,
    TError,
    { data: BodyType<GenerateSmartReplyRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateSmartReply>>,
  TError,
  { data: BodyType<GenerateSmartReplyRequest> },
  TContext
> => {
  const mutationKey = ["generateSmartReply"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateSmartReply>>,
    { data: BodyType<GenerateSmartReplyRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return generateSmartReply(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateSmartReplyMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateSmartReply>>
>;
export type GenerateSmartReplyMutationBody =
  BodyType<GenerateSmartReplyRequest>;
export type GenerateSmartReplyMutationError = ErrorType<unknown>;

/**
 * @summary Generate a polished reply to an email or message
 */
export const useGenerateSmartReply = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSmartReply>>,
    TError,
    { data: BodyType<GenerateSmartReplyRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateSmartReply>>,
  TError,
  { data: BodyType<GenerateSmartReplyRequest> },
  TContext
> => {
  return useMutation(getGenerateSmartReplyMutationOptions(options));
};

/**
 * @summary Get paginated reply history
 */
export const getGetReplyHistoryUrl = (params?: GetReplyHistoryParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/reply/history?${stringifiedParams}`
    : `/api/reply/history`;
};

export const getReplyHistory = async (
  params?: GetReplyHistoryParams,
  options?: RequestInit,
): Promise<ReplyHistoryResponse> => {
  return customFetch<ReplyHistoryResponse>(getGetReplyHistoryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetReplyHistoryQueryKey = (params?: GetReplyHistoryParams) => {
  return [`/api/reply/history`, ...(params ? [params] : [])] as const;
};

export const getGetReplyHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getReplyHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReplyHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReplyHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReplyHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReplyHistory>>> = ({
    signal,
  }) => getReplyHistory(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReplyHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReplyHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReplyHistory>>
>;
export type GetReplyHistoryQueryError = ErrorType<unknown>;

/**
 * @summary Get paginated reply history
 */

export function useGetReplyHistory<
  TData = Awaited<ReturnType<typeof getReplyHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReplyHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReplyHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReplyHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Delete a saved reply
 */
export const getDeleteReplyUrl = (replyId: string) => {
  return `/api/reply/${replyId}`;
};

export const deleteReply = async (
  replyId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteReplyUrl(replyId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteReplyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReply>>,
    TError,
    { replyId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReply>>,
  TError,
  { replyId: string },
  TContext
> => {
  const mutationKey = ["deleteReply"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReply>>,
    { replyId: string }
  > = (props) => {
    const { replyId } = props ?? {};

    return deleteReply(replyId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReplyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReply>>
>;

export type DeleteReplyMutationError = ErrorType<unknown>;

/**
 * @summary Delete a saved reply
 */
export const useDeleteReply = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReply>>,
    TError,
    { replyId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteReply>>,
  TError,
  { replyId: string },
  TContext
> => {
  return useMutation(getDeleteReplyMutationOptions(options));
};
